import React from 'react'
import { Modal, Button } from 'react-bootstrap'

interface ErrorDialogProps {
  show: boolean
  onHide: () => void
  title?: string
  message: React.ReactNode
  buttonText?: string
  variant?: 'primary' | 'danger' | 'warning' | 'success'
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({
  show,
  onHide,
  title = 'Error',
  message,
  buttonText = 'OK',
  variant = 'danger',
}) => {
  return (
    <Modal
      className="create-project-modal"
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className={`bg-${variant} text-white`}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-white">{message}</Modal.Body>
      <Modal.Footer className="bg-dark text-white d-flex justify-content-end">
        <Button variant={variant} onClick={onHide}>
          {buttonText}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ErrorDialog
